import React, { useState, useEffect } from 'react';
import './RegisterForm.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const RegisterForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [error, setError] = useState('');

  const closeModal = () => {
    console.log("Closing register modal");
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const { name, email, phone, message } = formData;

  if (!name || !email || !phone || !message) {
    setError('All fields are required');
    return;
  }

  try {
    const response = await fetch('http://localhost:5000/connect-now', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (response.ok) {
      alert(result.message || 'Form submitted successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setError('');
      closeModal();
    } else {
      setError(result.error || result.detail || 'Submission failed.');
    }
  } catch (err) {
    console.error("Submission failed:", err);
    setError("Something went wrong. Try again later.");
  }
};

  return (
    <AnimatePresence>
      <motion.div
        className="rf-modalOverlayX91"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={closeModal}
      >
        <motion.div
          className="rf-registerCardG88"
          initial={{ y: '-100vh', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100vh', opacity: 0 }}
          transition={{ duration: 0.5, type: 'spring' }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="rf-closeButtonR77" onClick={closeModal}>×</button>
          <h2 className="rf-titleL22">Register Here</h2>
          <form className="rf-formV55" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="rf-inputC12"
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              className="rf-inputC12"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="rf-inputC12"
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
              className="rf-textAreaX01"
            ></textarea>
            {error && <p className="rf-errorMsgT91">{error}</p>}
            <button type="submit" className="rf-submitBtnB76">Submit</button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default RegisterForm;